// @flow

export { InputEcuadorianDocument } from './input-ecuadorian-document';
export { InputEcuadorianPhoneNumber } from './input-ecuadorian-phone-number';
